import './core-utils/axios/axiosSetUp';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import type { CSSObject } from 'tss-react';
import {
  CARE_QUALITY,
  CLAIMS_METRICS,
  DISEASE_PRELAVENCE,
  CHRONIC_PREVALENCE,
  EPISODES_OF_CARE,
  EPISODES_OF_CARE_SELECTED,
  DISEASE_PRELAVENCE_BY_CONDITION,
  CHRONIC_PREVALENCE_BY_CONDITION,
  ENROLLMENT_METRICS,
  HIGH_COST_CLAIMS,
  HOME_ROUTE,
  HOME_SCREEN,
  LOGIN,
  LOGIN_CALLBACK,
  LOGIN_REDIRECT,
  MEMBER_SUMMARY,
  NETWORK_LEAKAGE,
  PATIENT_ADMISSION,
  PATIENT_DETAILS,
  PENDING_CLAIMS,
  PLAN_PERFORMANCE,
  PROCEDURE_UTILIZATION,
  PROVIDER_UTILIZATION,
  REJECTED_CLAIMS,
  REPORTS,
  REPORT_PLAN,
  RISING_RISK,
  RISING_RISK_DETAILS,
  RISK_PATIENT_DETAILS,
  RX_UTILIZATION,
  SIGNUP,
  STOPLOSS_TRIGGERS,
  STOPLOSS_REPORT,
  SUMMARY,
  UTILIZATION_METRICS,
  MED_PHARMA,
  OTHER_PRESCRIPTION,
  SPECIALITY_DRUGS,
  SETTINGS,
  ERROR,
  RESET_PASSWORD,
  CUSTOM_QUERY_BUILDER,
  WASTE_CALCULATOR,
  WASTE_CALCULATOR_DETAILS,
  SPECIFIC_DEDUCTIBLE_CORRIDORS,
  CARE_QUALITY_INTERNAL,
  KPI_TRACKER,
  KPI_TRACKER_INTERNAL,
  ONBOARDING,
  CONTRACT_RISK_ANALYSIS,
  CONTRACT_AIQ,
  CONTRACT_AIQ_INTERNAL,
  CONTRACT_AIQ_REPORTS,
  PROFILE,
  ACCESS_DASHBOARD,
  ACCESS_DASHBOARD_INTERNAL,
  PLAN_DOCUMENTS,
  PLAN_DOCUMENTS_INTERNAL,
  CUSTOM_ANALYSIS,
  CLAIM_ANALYSIS,
  RECOMMENDATIONS,
  TASK_BOARD,
  COMPLIANCE_REPORT,
  PLAYBOOK,
  PLAYBOOK_INTERNAL_PAGE,
  PLAYBOOK_DETAILS,
  GAG_CLAUSE_REPORT,
  GAG_CLAUSE_COMPLIANCE,
  REGULATORY_COMPLIANCE_REPORT,
  PURCHASING_STANDARDS_REPORT,
  COMPENSATION_TRANSPARENCY_REPORT,
  INTER_CONTRACT_REPORT,
  REPORTS_PPT,
  RISK_PROFILING_BY_CHRONIC,
  RISK_PROFILING_BY_TRIGGER,
  RISK_PROFILING_BY_COST,
  RISK_PROFILING_BY_UTILIZATION,
  GLP_DRUGS,
  CHRONIC_COHORT,
  HIGH_COST_COHORT,
  MULTIPLE_DRUG_COHORT,
  RISK_PROFILING_BY_DRUGS,
  MEMBER_LIST,
  CONTRACT_ONBOARDING,
  SAVINGS_UTILIZATION,
  DATA_CATALOGUE,
  MERGE_DOCUMENTS,
  PATIENT_CASES,
  CARE_NAVIGATOR,
  CARE_NAVIGATOR_PROFILE,
  TICKET_MANAGEMENT,
  STOPLOSS_TRIGGERS_INTERNAL,
  DRAFT_AGREEMENTS,
  DRAFT_SELECTED,
  COMPLIANCE_ASSURANCE,
  MA_DUE_DILIGENCE,
  MA_DUE_DILIGENCE_INTERNAL,
  MA_DUE_DILIGENCE_ADD,
  RISK_REGISTER,
  ONBOARDINGSTATUS,
  DOC_COMPARISON,
  NEW_DOC_COMPARISON,
  DOC_COMP_INTEGRAL,
  EXPERICENCE_SCREEN,
  ALL_INSIGHTS_NOTIFICATION,
  CUSTOMIZE_NOTIFICATION,
  FINANCIAL_FORENSICS,
  SCENARIO_WORKSPACE,
  SCENARIO_LIBRARY,
  RECONCILIATION_WORKSPACE,
  RECONCILIATION_LIBRARY,
  DEEP_DIVE,
  TERM_COMPILER,
  NEW_TERM_COMPILER,
  TERM_COMPILER_INTERNAL,
  ALL_REPORTS,
  CLAIMS_LIST,
  TREND_ANALYSIS,
  TREND_ANALYSIS_INTERNAL,
  ANNUAL_RENEWAL_PROCESS,
  RENEWAL_DETAILS,
  PLAYBOOK_AND_STANDARD,
  PLAYBOOK_AND_STANDARD_INTERNAL,
  PAYMENT_INTEGRITY,
  PAYMENT_INTEGRITY_INTERNAL,
  CMS_BENCHMARK,
  CMS_BENCHMARK_INTERNAL,
  CHAT,
  COHORT_COMPARISON,
  COHORT_COMPARISON_INTERNAL,
  PROPOSAL_ANALYZER,
} from './core-utils/routes';
import PatientDetails from './pages/PatientDetails';
import SideNavigationBar from './_components/organisms/SideNavigationBar';
import AppBar from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/AppBar';
import EnrollmentMetricsPage from './pages/EnrollmentMetricsPage';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import StopLossPage from './pages/StopLossPage';
import { observer } from 'mobx-react';
import SummaryPage from './pages/SummaryPage';
import LoginPage from './pages/LoginPage';
import properties from './core-utils/properties';
import LoginRedirectPage from './pages/LoginRedirectPage';
import HomePage from './pages/HomePage';
import UtilizationPatient from './pages/UtilizationPatient';
import NetworkLeakagePage from './pages/NetworkLeakagePage';
import UtilizationRx from './pages/UtilizationRx';
// import DiseasePrevalenceByConditionPage from './pages/DiseasePrevalenceByConditionNew';
import DiseasePrevalencePage from './pages/DiseasePrevalence';
import EpisodesOfCarePage from './pages/EpisodesOfCarePage';
import EpisodesOfCareSelected from './pages/EpisodesOfCareSelected';
import RisingRiskPage from './pages/RisingRiskPage';
// import HighCostClaimantsPage from './pages/HighCostClaimantsPage';
import ReportPlan from './pages/ReportPlan';
import MemberSummaryPage from './pages/MemberSummaryPage';
import ClaimMetricsPage from './pages/ClaimMetricsPage';
import UtilizationSummaryPage from './pages/UtilizationSummaryPage';
import { scrollBarStyles } from './core-utils/messages/CommonConstants';
import UtilizationProcedurePage from './pages/UtilizationProcedurePage';
import RiskPatientDetailsPage from './pages/RiskPatientDetailsPage';
import { useStores } from './stores';
import axios from 'axios';
import RejectedClaimStatusPage from './pages/RejectedClaimStatusPage';
import PendingClaimStatusPage from './pages/PendingClaimStatusPage';
import PlanPerformance from './pages/PlanPerformance';
import UtilizationProvider from './pages/UtilizationProvider';
import CareQualityPage from './pages/CareQualityPage';
import RisingRiskDetailsPage from './pages/RisingRiskDetailsPage';
import PopUpNotifer from './_components/molecules/PopUpNotifier';
import Reports from './pages/Reports';
import MedPharmaPage from './pages/MedPharmaPage';
import SpecialityDrugsPage from './pages/SpecialityDrugsPage';
import OtherPrescriptionPage from './pages/OtherPrescriptionPage';
import { arrayToString } from './core-utils/helper-utils/helper';
import ErrorPage from './pages/ErrorPage';
import { toJS } from 'mobx';
import { allRoutes, basicRoutes } from './core-utils/routesHelper';
import { UserAccessConstants } from './core-utils/helper-utils/userAccess';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CustomQueryPage from './pages/CustomQueryPage';
import WasteCalculatorPage from './pages/WasteCalculatorPage';
import WasteCalculatorDetailsPage from './pages/WasteCalculatorDetailsPage';
import SpecificDeductibleCorridors from './pages/SpecificDeductibleCorridors';
import ChronicPrevalencePage from './pages/ChronicPrevalence';
import CareQualityInternalPage from './pages/CareQualityInternalPage';
import KpiTrackerPage from './pages/KpiTrackerPage';
import KpiTrackerInternalPage from './pages/KpiTrackerInternalPage';
import OnboardingPage from './pages/OnboardingPage';
import ContractAiqAnalysis from './pages/ContractAiqAnalysisPage';
import ContractAiq from './pages/ContractAiq';
import ContractReportPage from './pages/ContractReportPage';
import ProfilePage from './pages/ProfilePage';
import AccessDashboard from './pages/AccessDashboardPage';
import AccessDashboardInternal from './pages/AccessDashboardInternalPage';
import ClaimAnalysisPage from './pages/ClaimAnalysisPage';
import StopLossAggregateReport from './pages/StopLossAggregateReportPage';
import PlaybookPage from './pages/PlaybookPage';
import PlaybookInternalPage from './pages/PlaybookInternalPage';
import PlaybookDetailsPage from './pages/PlaybookDetailsPage';
import GagClauseReport from './pages/GagClauseReportPage';
import GagClauseCompliancePage from './pages/GagClauseCompliancePage';
import RegulatoryComplianceReport from './pages/RegulatoryComplianceReportPage';
import PurchasingStandardsReport from './pages/PurchasingStandardsReportPage';
import CompensationTransparencyReport from './pages/CompensationTransparencyReportPage';
import InterContractReport from './pages/InterContractReport';
import ReportsPpt from './pages/ReportsPpt';
import RiskProfiling from './pages/RiskProfilingPage';
import GLPDrug from './pages/GLPDrugsPage';
import HighCostClaimantsPage from './pages/HighCostClaimantsPageNew';
import CohortScreen from './pages/CohortPage';
import MemberList from './pages/MemberListPage';
import ContractOnBoarding from './pages/ContractOnBoardingPage';
import SavingsUtilization from './pages/SavingsUtilization';
import DiseaseInternalPage from './pages/DiseaseInternalPage';
import DataCataloguePage from './pages/DataCataloguePage';
import ContractDetails from './pages/ContractDetailsPage';
import ContractMergeDocument from './pages/ContractMergeDocumentsPage';
import PatientCasesPage from './pages/PatientCasesPage';
import CareNavigatorPage from './pages/CareNavigatorPage';
import CareNavigatorProfile from './pages/CareNavigatorProfilePage';
import TicketManagementPage from './pages/TicketManagementPage';
import UserManagementPage from './pages/NewUserManagementPage';
import ComplianceReports from './pages/ComplianceReports';
import DraftAgreement from './pages/DraftAgreementsPage';
import MADueDiligencePage from './pages/MADueDiligencePage';
import MADueDiligenceInternalPage from './pages/MADueDiligenceInternalPage';
import MADueDiligenceAddProjectPage from './pages/MADueDiligenceAddProjectPage';
import RiskRegistepage from './pages/RiskRegisterPage';
import TaskBoardPage from './pages/TaskBoardPage';
import OnBoardingStatusPage from './pages/OnBoardingStatusPage';
// import ChronicPrevalenceByConditionPage from './pages/ChronicPrevalenceByConditionNew';
import PlanDocuments from './pages/PlanDocuments';
import PlanDocumentDetailsPage from './pages/PlanDocumentDetailsPage';
import DocumentComparisonPage from './pages/DocumentComparisonPage';
import NewComparisonPage from './pages/NewComparisonPage';
import DocumentComparisonInternalPage from './pages/DocumentComparisonIntegral';
import ExperiencePage from './pages/ExperiencePage';
import AllInsigntsAndNotification from './_components/organisms/ExperienceTabs/AllInsightsNotif';
import CustomizeNotification from './_components/organisms/ExperienceTabs/CustomizeNotification';
import FinancialForensics from './pages/FinancialForensicsPage';
import BuildScenarioWorkspacePage from './pages/BuildScenarioWorkspace';
import ScenarioLibrary from './pages/ScenarioLibrary';
import ReconciliationWorkspace from './pages/ReconciliationWorkspace';
import ReconciliationLibrary from './pages/ReconciliationLibrary';
import DeepDivePage from './pages/DeepDivePage';
import TermCompilerPage from './pages/TermCompilerPage';
import NewTermCompilerPage from './pages/NewTermCompilerPage';
import TermCompilerInternalPage from './pages/TermCompilerInternalPage';
import AllReports from './pages/AllReportsPage';
import TrendAnalysisInternalPage from './pages/TrendAnalysisInternalPage';
import AnnualRenewalProcess from './pages/AnnualRenewalProcess';
import RenewalDetailsPage from './pages/RenewalDetailsPage';
import PlaybookAndStandard from './pages/PlaybookAndStandard';
import PlaybookAndStandardInternal from './pages/PlaybookAndStandardInternal';
import PaymentIntegrityPage from './pages/PaymentIntegrityPage';
import PaymentIntegrityInternalPage from './pages/PaymentIntegrityInternalPage';
import BenchmarkPage from './pages/BenchmarkPage';
import BenchmarkInternalPage from './pages/BenchmarkInternalPage';
import ChatPage from './pages/ChatPage';
import { useIdleTimeout } from './core-utils/custom-hooks/UserIdleLogout';
import IdleWarningModal from './_components/molecules/IdleWarningModal';
import CohortComparisonPage from './pages/CohortComparisonPage';
import CohortComparisonInternalPage from './pages/CohortComparisonInternalPage';
import ProposalAnalyzer from './pages/ProposalAnalyzer';
import TrendAnalysisLibraryPage from './pages/TrendAnalysisLibrary';

const routes = [
  {
    path: SUMMARY,
    exact: true,
    main: () => <SummaryPage />,
  },
  {
    path: DISEASE_PRELAVENCE,
    exact: true,
    main: () => <DiseasePrevalencePage />,
  },
  {
    path: CHRONIC_PREVALENCE,
    exact: true,
    main: () => <ChronicPrevalencePage />,
  },
  {
    path: DISEASE_PRELAVENCE_BY_CONDITION,
    exact: true,
    main: () => <DiseaseInternalPage type="disease" />,
  },
  {
    path: CHRONIC_PREVALENCE_BY_CONDITION,
    exact: true,
    main: () => <DiseaseInternalPage type="chronic" />,
  },
  {
    path: RISING_RISK,
    main: () => <RisingRiskPage />,
  },
  {
    path: RISING_RISK_DETAILS,
    main: () => <RisingRiskDetailsPage />,
  },
  {
    path: CARE_QUALITY,
    main: () => <CareQualityPage />,
  },
  {
    path: CARE_QUALITY_INTERNAL,
    main: () => <CareQualityInternalPage />,
  },
  {
    path: EPISODES_OF_CARE,
    exact: true,
    main: () => <EpisodesOfCarePage />,
  },
  {
    path: EPISODES_OF_CARE_SELECTED,
    exact: true,
    main: () => <EpisodesOfCareSelected />,
  },
  {
    path: HIGH_COST_CLAIMS,
    main: () => <HighCostClaimantsPage />,
  },
  {
    path: STOPLOSS_TRIGGERS,
    main: () => (
      <>
        <StopLossPage />
      </>
    ),
  },
  {
    path: STOPLOSS_TRIGGERS_INTERNAL,
    main: () => (
      <>
        <DiseaseInternalPage type="stoploss" />
      </>
    ),
  },
  {
    path: REPORT_PLAN,
    main: () => (
      <>
        <ReportPlan />
      </>
    ),
  },
  {
    path: PLAN_PERFORMANCE,
    main: () => (
      <>
        <PlanPerformance />
      </>
    ),
  },
  {
    path: CLAIMS_METRICS,
    main: () => <ClaimMetricsPage />,
  },
  {
    path: ENROLLMENT_METRICS,
    main: () => (
      <>
        <EnrollmentMetricsPage />
      </>
    ),
  },
  {
    path: REJECTED_CLAIMS,
    main: () => (
      <>
        <RejectedClaimStatusPage />
      </>
    ),
  },
  {
    path: PENDING_CLAIMS,
    main: () => (
      <>
        <PendingClaimStatusPage />
      </>
    ),
  },
  {
    path: NETWORK_LEAKAGE,
    main: () => (
      <>
        <NetworkLeakagePage />
      </>
    ),
  },
  {
    path: UTILIZATION_METRICS,
    main: () => <UtilizationSummaryPage />,
  },
  {
    path: PATIENT_ADMISSION,
    main: () => <UtilizationPatient />,
  },
  {
    path: RX_UTILIZATION,
    main: () => (
      <>
        <UtilizationRx />
      </>
    ),
  },
  {
    path: PROCEDURE_UTILIZATION,
    main: () => (
      <>
        <UtilizationProcedurePage />
      </>
    ),
  },
  {
    path: PROVIDER_UTILIZATION,
    main: () => (
      <>
        <UtilizationProvider />
      </>
    ),
  },
  // {
  //   path: USER_MANAGEMENT,
  //   main: () => <UserManagementPage />,
  // },
  {
    path: HOME_SCREEN,
    main: () => <HomePage />,
  },
  {
    path: SETTINGS,
    main: () => <UserManagementPage />,
  },
  {
    path: RISK_PATIENT_DETAILS,
    main: () => (
      <>
        <RiskPatientDetailsPage />
      </>
    ),
  },
  {
    path: MED_PHARMA,
    main: () => (
      <>
        <MedPharmaPage />
      </>
    ),
  },
  {
    path: SPECIALITY_DRUGS,
    main: () => (
      <>
        <SpecialityDrugsPage />
      </>
    ),
  },
  {
    path: OTHER_PRESCRIPTION,
    main: () => (
      <>
        <OtherPrescriptionPage />
      </>
    ),
  },
  {
    path: CUSTOM_QUERY_BUILDER,
    main: () => (
      <>
        <CustomQueryPage />
      </>
    ),
  },
  {
    path: WASTE_CALCULATOR,
    main: () => (
      <>
        <WasteCalculatorPage />
      </>
    ),
  },
  {
    path: WASTE_CALCULATOR_DETAILS,
    main: () => (
      <>
        <WasteCalculatorDetailsPage />
      </>
    ),
  },
  {
    path: SPECIFIC_DEDUCTIBLE_CORRIDORS,
    main: () => (
      <>
        <SpecificDeductibleCorridors />
      </>
    ),
  },
  {
    path: KPI_TRACKER,
    main: () => (
      <>
        <KpiTrackerPage />
      </>
    ),
  },
  {
    path: CONTRACT_RISK_ANALYSIS,
    main: () => (
      <>
        <ContractAiqAnalysis />
      </>
    ),
  },
  {
    path: CONTRACT_AIQ_INTERNAL,
    main: () => (
      <>
        <ContractDetails />
      </>
    ),
  },
  {
    path: CONTRACT_AIQ,
    main: () => (
      <>
        <ContractAiq />
      </>
    ),
  },
  {
    path: CONTRACT_AIQ_REPORTS,
    main: () => (
      <>
        <ContractReportPage />
      </>
    ),
  },
  {
    path: KPI_TRACKER_INTERNAL,
    main: () => (
      <>
        <KpiTrackerInternalPage />
      </>
    ),
  },
  {
    path: ONBOARDING,
    main: () => <OnboardingPage />,
  },
  {
    path: ONBOARDINGSTATUS,
    main: () => <OnBoardingStatusPage />,
  },
  {
    path: PROFILE,
    main: () => <ProfilePage />,
  },
  {
    path: ACCESS_DASHBOARD,
    exact: true,
    main: () => (
      <>
        <AccessDashboard />
      </>
    ),
  },
  {
    path: ACCESS_DASHBOARD_INTERNAL,
    exact: true,
    main: () => (
      <>
        <AccessDashboardInternal />
      </>
    ),
  },
  {
    path: COMPLIANCE_ASSURANCE,
    exact: true,
    main: () => (
      <>
        <AccessDashboard />
      </>
    ),
  },
  {
    path: PLAN_DOCUMENTS,
    exact: true,
    main: () => (
      <>
        <PlanDocuments />
      </>
    ),
  },
  {
    path: CUSTOM_ANALYSIS,
    exact: true,
    main: () => (
      <>
        <AccessDashboard />
      </>
    ),
  },
  {
    path: RECOMMENDATIONS,
    exact: true,
    main: () => (
      <>
        <AccessDashboard />
      </>
    ),
  },
  {
    path: CLAIM_ANALYSIS,
    exact: true,
    main: () => (
      <>
        <ClaimAnalysisPage />
      </>
    ),
  },
  {
    path: REPORTS,
    exact: true,
    main: () => (
      <>
        <Reports />
      </>
    ),
  },
  {
    path: ALL_REPORTS,
    exact: true,
    main: () => (
      <>
        <AllReports />
      </>
    ),
  },
  {
    path: REPORTS_PPT,
    exact: true,
    main: () => (
      <>
        <ReportsPpt />
      </>
    ),
  },
  {
    path: PLAN_DOCUMENTS_INTERNAL,
    exact: true,
    main: () => (
      <>
        <PlanDocumentDetailsPage />
      </>
    ),
  },
  {
    path: TASK_BOARD,
    exact: true,
    main: () => <TaskBoardPage />,
  },
  {
    path: DEEP_DIVE,
    exact: true,
    main: () => <DeepDivePage />,
  },
  {
    path: TREND_ANALYSIS,
    exact: true,
    main: () => <TrendAnalysisLibraryPage />,
  },
  {
    path: TREND_ANALYSIS_INTERNAL,
    exact: true,
    main: () => <TrendAnalysisInternalPage />,
  },
  {
    path: COHORT_COMPARISON,
    exact: true,
    main: () => <CohortComparisonPage />,
  },
  {
    path: COHORT_COMPARISON_INTERNAL,
    exact: true,
    main: () => <CohortComparisonInternalPage />,
  },
  {
    path: COMPLIANCE_REPORT,
    exact: true,
    main: () => (
      <>
        <ComplianceReports />
      </>
    ),
  },
  {
    path: PLAYBOOK,
    exact: true,
    main: () => (
      <>
        <PlaybookPage />
      </>
    ),
  },
  {
    path: GAG_CLAUSE_COMPLIANCE,
    exact: true,
    main: () => (
      <>
        <GagClauseCompliancePage />
      </>
    ),
  },
  {
    path: STOPLOSS_REPORT,
    exact: true,
    main: () => (
      <>
        <StopLossAggregateReport />
      </>
    ),
  },
  {
    path: PLAYBOOK_INTERNAL_PAGE,
    exact: true,
    main: () => (
      <>
        <PlaybookInternalPage />
      </>
    ),
  },
  {
    path: PLAYBOOK_DETAILS,
    exact: true,
    main: () => (
      <>
        <PlaybookDetailsPage />
      </>
    ),
  },
  {
    path: GAG_CLAUSE_REPORT,
    exact: true,
    main: () => (
      <>
        <GagClauseReport />
      </>
    ),
  },
  {
    path: REGULATORY_COMPLIANCE_REPORT,
    exact: true,
    main: () => (
      <>
        <RegulatoryComplianceReport />
      </>
    ),
  },
  {
    path: PURCHASING_STANDARDS_REPORT,
    exact: true,
    main: () => (
      <>
        <PurchasingStandardsReport />
      </>
    ),
  },
  {
    path: COMPENSATION_TRANSPARENCY_REPORT,
    exact: true,
    main: () => (
      <>
        <CompensationTransparencyReport />
      </>
    ),
  },
  {
    path: CLAIMS_LIST,
    main: () => (
      <>
        <CustomQueryPage />
      </>
    ),
  },
  {
    path: INTER_CONTRACT_REPORT,
    exact: true,
    main: () => (
      <>
        <InterContractReport />
      </>
    ),
  },
  {
    path: RISK_PROFILING_BY_CHRONIC,
    exact: true,
    main: () => (
      <>
        <RiskProfiling type={'chronic'} />
      </>
    ),
  },
  {
    path: RISK_PROFILING_BY_TRIGGER,
    exact: true,
    main: () => (
      <>
        <RiskProfiling type={'trigger'} />
      </>
    ),
  },
  {
    path: RISK_PROFILING_BY_COST,
    exact: true,
    main: () => (
      <>
        <RiskProfiling type={'cost'} />
      </>
    ),
  },
  {
    path: RISK_PROFILING_BY_UTILIZATION,
    exact: true,
    main: () => (
      <>
        <RiskProfiling type={'utilization'} />
      </>
    ),
  },
  {
    path: GLP_DRUGS,
    exact: true,
    main: () => (
      <>
        <GLPDrug />
      </>
    ),
  },
  {
    path: CHRONIC_COHORT,
    exact: true,
    main: () => (
      <>
        <CohortScreen type={'chronic'} />
      </>
    ),
  },
  {
    path: HIGH_COST_COHORT,
    exact: true,
    main: () => (
      <>
        <CohortScreen type={'cost'} />
      </>
    ),
  },
  {
    path: MEMBER_LIST,
    exact: true,
    main: () => (
      <>
        <MemberList />
      </>
    ),
  },
  {
    path: MULTIPLE_DRUG_COHORT,
    exact: true,
    main: () => (
      <>
        <CohortScreen type={'drugs'} />
      </>
    ),
  },
  {
    path: RISK_PROFILING_BY_DRUGS,
    exact: true,
    main: () => (
      <>
        <RiskProfiling type={'drugs'} />
      </>
    ),
  },
  {
    path: MERGE_DOCUMENTS,
    main: () => <ContractMergeDocument />,
  },
  {
    path: SAVINGS_UTILIZATION,
    exact: true,
    main: () => (
      <>
        <SavingsUtilization />
      </>
    ),
  },
  {
    path: CONTRACT_ONBOARDING,
    exact: true,
    main: () => (
      <>
        <ContractOnBoarding />
      </>
    ),
  },
  {
    path: DATA_CATALOGUE,
    exact: true,
    main: () => (
      <>
        <DataCataloguePage />
      </>
    ),
  },
  { path: CARE_NAVIGATOR, main: () => <CareNavigatorPage /> },
  { path: CARE_NAVIGATOR_PROFILE, main: () => <CareNavigatorProfile /> },
  {
    path: TICKET_MANAGEMENT,
    exact: true,
    main: () => (
      <>
        <TicketManagementPage />
      </>
    ),
  },
  {
    path: DRAFT_AGREEMENTS,
    exact: true,
    main: () => (
      <>
        <DraftAgreement />
      </>
    ),
  },
  {
    path: DRAFT_SELECTED,
    main: () => (
      <>
        <ContractDetails />
      </>
    ),
  },
  {
    path: MA_DUE_DILIGENCE,
    main: () => (
      <>
        <MADueDiligencePage />
      </>
    ),
  },
  {
    path: MA_DUE_DILIGENCE_INTERNAL,
    main: () => (
      <>
        <MADueDiligenceInternalPage />
      </>
    ),
  },
  {
    path: DOC_COMPARISON,
    main: () => (
      <>
        <DocumentComparisonPage />
      </>
    ),
  },
  {
    path: NEW_DOC_COMPARISON,
    main: () => (
      <>
        <NewComparisonPage />
      </>
    ),
  },
  {
    path: DOC_COMP_INTEGRAL,
    main: () => (
      <>
        <DocumentComparisonInternalPage />
      </>
    ),
  },
  {
    path: TERM_COMPILER,
    main: () => (
      <>
        <TermCompilerPage />
      </>
    ),
  },
  {
    path: NEW_TERM_COMPILER,
    main: () => (
      <>
        <NewTermCompilerPage />
      </>
    ),
  },
  {
    path: TERM_COMPILER_INTERNAL,
    main: () => (
      <>
        <TermCompilerInternalPage />
      </>
    ),
  },
  {
    path: MA_DUE_DILIGENCE_ADD,
    main: () => (
      <>
        <MADueDiligenceAddProjectPage />
      </>
    ),
  },
  {
    path: RISK_REGISTER,
    main: () => (
      <>
        <RiskRegistepage />
      </>
    ),
  },
  {
    path: EXPERICENCE_SCREEN,
    main: () => (
      <>
        <ExperiencePage />
      </>
    ),
  },
  {
    path: ALL_INSIGHTS_NOTIFICATION,
    main: () => (
      <>
        <AllInsigntsAndNotification />
      </>
    ),
  },
  {
    path: CUSTOMIZE_NOTIFICATION,
    main: () => (
      <>
        <CustomizeNotification />
      </>
    ),
  },
  {
    path: FINANCIAL_FORENSICS,
    main: () => (
      <>
        <FinancialForensics />
      </>
    ),
  },
  {
    path: SCENARIO_WORKSPACE,
    main: () => (
      <>
        <BuildScenarioWorkspacePage />
      </>
    ),
  },
  {
    path: SCENARIO_LIBRARY,
    main: () => (
      <>
        <ScenarioLibrary />
      </>
    ),
  },
  {
    path: RECONCILIATION_WORKSPACE,
    main: () => (
      <>
        <ReconciliationWorkspace />
      </>
    ),
  },
  {
    path: RECONCILIATION_LIBRARY,
    main: () => (
      <>
        <ReconciliationLibrary />
      </>
    ),
  },
  {
    path: ANNUAL_RENEWAL_PROCESS,
    exact: true,
    main: () => (
      <>
        <AnnualRenewalProcess />
      </>
    ),
  },
  {
    path: RENEWAL_DETAILS,
    exact: true,
    main: () => (
      <>
        <RenewalDetailsPage />
      </>
    ),
  },
  {
    path: PLAYBOOK_AND_STANDARD,
    main: () => (
      <>
        <PlaybookAndStandard />
      </>
    ),
  },
  {
    path: PLAYBOOK_AND_STANDARD_INTERNAL,
    main: () => (
      <>
        <PlaybookAndStandardInternal />
      </>
    ),
  },
  {
    path: PAYMENT_INTEGRITY,
    exact: true,
    main: () => <PaymentIntegrityPage />,
  },
  {
    path: PAYMENT_INTEGRITY_INTERNAL,
    exact: true,
    main: () => <PaymentIntegrityInternalPage />,
  },
  {
    path: CMS_BENCHMARK,
    exact: true,
    main: () => <BenchmarkPage />,
  },
  {
    path: CMS_BENCHMARK_INTERNAL,
    exact: true,
    main: () => <BenchmarkInternalPage />,
  },
  {
    path: CHAT,
    exact: true,
    main: () => <ChatPage />,
  },
  {
    path: PROPOSAL_ANALYZER,
    exact: true,
    main: () => (
      <>
        <ProposalAnalyzer />
      </>
    ),
  },
];

const routesWithoutNavBar = [
  HOME_ROUTE,
  LOGIN,
  SIGNUP,
  LOGIN_REDIRECT,
  HOME_SCREEN,
  LOGIN_CALLBACK,
  ERROR,
  RESET_PASSWORD,
  ONBOARDING,
  PLAYBOOK_DETAILS,
];

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  const token = JSON.parse(localStorage.getItem('token-storage') || '{}')
    ?.access_token;

  return token ? children : <Navigate to="/login" replace />;
};

const AppWithRouteAccess = observer(() => {
  const { classes } = makeStyles()({
    contentGrid: {
      width: 'calc(100% - 69px)',
      height: 'calc(100vh - 59px)',
      overflow: 'auto',
      ...(scrollBarStyles as CSSObject),
    },
  })();

  const location = useLocation();
  const navigate = useNavigate();
  const [prevRoute, setPrevRoute] = useState<string>(LOGIN);
  const [route, setRoute] = useState({ to: location.pathname, from: '' });

  const loginPageStore = useStores().loginPageStore;
  const employerGroupStore = useStores().employerGroupStore;
  const careNavigatorStore = useStores().careNavigatorStore;
  const customQueriesStore = useStores().customQueriesStore;
  const userAccessRoutes = loginPageStore.userAccessRoutes;
  const isCareNavigator = loginPageStore.isCareNavigator;
  const cohortDetailsStore = useStores().cohortDetailsStore;

  const isLoggedIn = Boolean(
    JSON.parse(localStorage.getItem('token-storage') || '{}')?.access_token,
  );

  const { isWarning, remainingSeconds, dismissWarning } = useIdleTimeout({
    idleTimeoutMs: process.env.IDLE_TIMEOUT_MS
      ? parseInt(process.env.IDLE_TIMEOUT_MS) * 60 * 1000
      : 15 * 60 * 1000,
    warningTimeMs: 2 * 60 * 1000,
    enabled: isLoggedIn,
    onIdle: () => {
      handleLogout();
    },
  });

  const withoutSideBarPages = [
    SETTINGS,
    HOME_SCREEN,
    PROFILE,
    // CARE_NAVIGATOR,
    PATIENT_CASES,
    CARE_NAVIGATOR_PROFILE,
    TICKET_MANAGEMENT,
  ];

  // ----------- Handle user access logic ------------
  const handleDynamicRoute = (route: string) => {
    const currentPath = location.pathname;
    return !currentPath
      .substring(currentPath.indexOf(route) + route.length + 1)
      .includes('/');
  };

  /*
    Checks if the current route is dynamic and valid
    Dynamic route eg:- /disease-prevalence/:condition -> condition keeps on changing
  */
  const validateDynamicRoute = () => {
    const dynamicRoutes = [
      DISEASE_PRELAVENCE,
      CHRONIC_PREVALENCE,
      ACCESS_DASHBOARD,
    ];
    for (const route of dynamicRoutes) {
      if (
        location.pathname?.includes(route) &&
        toJS(loginPageStore.userAccessRoutes)?.includes(route)
      ) {
        return handleDynamicRoute(route);
      }
    }
    return false;
  };

  const handleUserAccess = () => {
    const { pathname } = location;

    // Give access to basic routes
    if (basicRoutes.includes(pathname)) {
      setPrevRoute(location.pathname);
      return;
    }

    /* if super admin, give access to all possible routes, 
       if a dynamic route comes, it will be handled by below checks
    */
    if (
      loginPageStore.userResponse.role.name ===
        UserAccessConstants.SUPER_ADMIN &&
      allRoutes.includes(location.pathname)
    ) {
      return;
    }

    const userAccessRoutes = toJS(loginPageStore.userAccessRoutes);

    if (validateDynamicRoute() || userAccessRoutes?.includes(pathname)) {
      setPrevRoute(location.pathname);
    } else if (
      userAccessRoutes?.length &&
      !userAccessRoutes?.includes(pathname)
    ) {
      navigate(ERROR, { state: { from: prevRoute } });
    }
  };

  // ------------- Axios Token Setup --------------
  useEffect(() => {
    const tokenStorage = JSON.parse(
      localStorage.getItem('token-storage') || '{}',
    );
    const accessToken = tokenStorage?.access_token;
    const refreshToken = tokenStorage?.refresh_token;

    if (accessToken) {
      axios.defaults.headers.common['Authorization'] = accessToken;
      axios.defaults.headers.common['Cache-Control'] = 'no-store';
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }

    let isRefreshing = false;
    let refreshPromise: Promise<any> | null = null;
    let failedQueue: any[] = [];

    const processQueue = (error: any, token: string | null = null) => {
      failedQueue.forEach((prom) => {
        if (error) {
          prom.reject(error);
        } else {
          prom.resolve(token);
        }
      });
      failedQueue = [];
    };

    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

        if (error?.response?.status !== 401 || originalRequest._retry) {
          return Promise.reject(error);
        }

        // If already refreshing, wait for it to finish
        if (isRefreshing && refreshPromise) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers['Authorization'] = token;
              return axios(originalRequest);
            })
            .catch((err) => Promise.reject(err));
        }

        originalRequest._retry = true;
        isRefreshing = true;

        // Start refresh only once
        refreshPromise = new Promise(async (resolve, reject) => {
          try {
            const res = await axios.post(
              `${properties.userManagementBaseUrl}${properties.users}${properties.refreshToken}`,
              { refresh_token: refreshToken },
            );

            const newAccessToken = res?.data?.access_token;
            localStorage.setItem(
              'token-storage',
              JSON.stringify({
                ...tokenStorage,
                access_token: newAccessToken,
              }),
            );

            axios.defaults.headers.common['Authorization'] = newAccessToken;
            processQueue(null, newAccessToken);

            resolve(newAccessToken);
          } catch (refreshError) {
             
            console.error('Refresh token failed:', refreshError);
            processQueue(refreshError, null);
            localStorage.clear();
            delete axios.defaults.headers.common['Authorization'];
            navigate('/login');
            reject(refreshError);
          } finally {
            isRefreshing = false;
            refreshPromise = null;
          }
        });

        // Wait for the single refresh call result
        const newToken = await refreshPromise;
        originalRequest.headers['Authorization'] = newToken;
        return axios(originalRequest);
      },
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate]);

  // ------------- Logout Handler -------------
  const handleLogout = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('token-storage') || '{}')
        ?.access_token;
      if (token) {
        axios.get(
          `${properties.userManagementBaseUrl}${properties.users}/logout`,
        );
        localStorage.clear();
        // ✅ Reset cohort details (same as modal close)
        cohortDetailsStore.setCohortDetailsList([
          {
            id: 1,
            category: '',
            condition: '',
            property: '',
            results: '',
            dropdownSelectionTypeIndex: 0,
            andOrCondition: 'AND',
            propertiesPageNumber: 0,
            totalPagesForProperties: 0,
          },
        ]);
        cohortDetailsStore.removeConditionsDetails();
        cohortDetailsStore.removeClaimIdList();
        cohortDetailsStore.removeMemberUniqueIdList();
        navigate('/login');
      }
    } catch (error) {
       
      console.error('Logout failed:', error);
    }
  };

  useEffect(() => {
    if (location.pathname !== route.to) {
      setRoute({ to: location.pathname, from: route.to });
    }
    handleUserAccess();

    return () => {
      cohortDetailsStore.resetMemberData();
    };
  }, [location.pathname]);

  return (
    <>
      {routesWithoutNavBar.includes(location?.pathname) ? (
        <Routes>
          {/* Routes without sidebar or header */}
          <Route path={HOME_ROUTE} element={<div>welcome to AIQ v2</div>} />
          <Route
            path={PATIENT_DETAILS}
            element={
              <RequireAuth>
                <PatientDetails />
              </RequireAuth>
            }
          />
          <Route path="/" element={<Navigate to={LOGIN} replace />} />
          <Route path={LOGIN} element={<LoginPage />} />
          <Route path={LOGIN_REDIRECT} element={<LoginRedirectPage />} />
          <Route
            path={HOME_SCREEN}
            element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>
            }
          />
          <Route path={ERROR} element={<ErrorPage />} />
          <Route path={RESET_PASSWORD} element={<ResetPasswordPage />} />
          <Route
            path={ONBOARDING}
            element={
              <RequireAuth>
                <OnboardingPage />
              </RequireAuth>
            }
          />
          <Route
            path={ONBOARDINGSTATUS}
            element={
              <RequireAuth>
                <OnBoardingStatusPage />
              </RequireAuth>
            }
          />
          <Route path={PLAYBOOK_DETAILS} element={<PlaybookDetailsPage />} />
        </Routes>
      ) : (
        <Grid
          container
          style={{ minWidth: '1380px', width: '100%', position: 'relative' }}
        >
          <Grid style={{ minWidth: '1372px', width: '100%' }}>
            <AppBar
              userName={loginPageStore.firstName}
              showSettings={
                loginPageStore.userResponse.role.name !==
                  UserAccessConstants.USER && !isCareNavigator
              }
              showDropdown={false}
              handleLogout={handleLogout}
              handleLogoOnclick={() => {
                employerGroupStore.removeDeductibleAmount();
                employerGroupStore.removeMemberIdsCrossing50PercentDeductible();
                navigate(HOME_SCREEN);
              }}
              handleSettings={() => navigate(SETTINGS)}
              showEmployerGroup={true}
              initialEmployer={
                arrayToString(
                  employerGroupStore?.employerGroupResponseData
                    ?.employer_group_name,
                ) !== ''
                  ? arrayToString(
                      employerGroupStore?.employerGroupResponseData
                        ?.employer_group_name,
                    )
                  : careNavigatorStore.group_name
              }
              showHelp={true}
              handleHelp={() => {
                navigate(TICKET_MANAGEMENT, {
                  state: {
                    previousRoute: location.pathname,
                  },
                });
              }}
              handleProfile={() =>
                navigate(PROFILE, {
                  state: { previousRoute: location.pathname },
                })
              }
            />
          </Grid>
          <Grid style={{ width: '69px', height: '10vh' }}></Grid>
          <Grid
            style={{
              position: 'absolute',
              left: '0px',
              top: '64px',
              backgroundColor: patientAccessTheme.palette.status.white,
              zIndex: 10000,
            }}
          >
            {!withoutSideBarPages.includes(location.pathname) &&
              (location.pathname !== CUSTOM_QUERY_BUILDER ||
                customQueriesStore.isIndividualGroup) && (
                <SideNavigationBar
                  userAccessRoutes={userAccessRoutes}
                  disableUserMangement={loginPageStore.isAdmin}
                />
              )}
          </Grid>
          <Grid id="content-grid" className={classes.contentGrid}>
            <PopUpNotifer />
            <Routes>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<RequireAuth>{route.main()}</RequireAuth>}
                />
              ))}
              <Route
                path={PATIENT_DETAILS}
                element={
                  <RequireAuth>
                    <PatientDetails />
                  </RequireAuth>
                }
              />
              <Route
                path={MEMBER_SUMMARY}
                element={
                  <RequireAuth>
                    <MemberSummaryPage />
                  </RequireAuth>
                }
              />
              <Route
                path={PATIENT_CASES}
                element={
                  <RequireAuth>
                    <PatientCasesPage />
                  </RequireAuth>
                }
              />
            </Routes>
          </Grid>
        </Grid>
      )}
      {isWarning && (
        <IdleWarningModal
          remainingSeconds={remainingSeconds}
          onStayLoggedIn={dismissWarning}
          onLogoutNow={handleLogout}
          open={isWarning}
        />
      )}
    </>
  );
});

export default AppWithRouteAccess;
